import type { InsiderService } from 'app/services/Insider';

const InsiderServiceWeb: InsiderService = {
  init() {},
};

export default InsiderServiceWeb;
